/**
 * How much of a long value is shown before Show all: about six lines of a
 * phone, counted in characters and in lines as typed, because the cut has to be
 * the same on every screen for the button to mean anything.
 */
export const CLAMP_CHARS = 280;
export const CLAMP_LINES = 6;

/** The start of a long value, ending in an ellipsis; null when the value is short enough to show whole. */
export function shortened(text: string): string | null {
  const lines = text.split('\n');
  let head = lines.length > CLAMP_LINES ? lines.slice(0, CLAMP_LINES).join('\n') : text;

  if (head.length > CLAMP_CHARS) {
    head = head.slice(0, CLAMP_CHARS);
    // Back to the end of the last whole word, unless that gives away half of what is shown.
    const gap = head.search(/\s\S*$/);
    if (gap > CLAMP_CHARS / 2) head = head.slice(0, gap);
    // Never half of a character that takes two code units.
    const last = head.charCodeAt(head.length - 1);
    if (last >= 0xd800 && last <= 0xdbff) head = head.slice(0, -1);
  }

  return head === text ? null : `${head.trimEnd()}…`;
}
